import CustomTable from "../../../../../common/custom-table/custom-table";
import styles from "./view-details.module.css";
import CustomProfileAvatar from "../../../../../common/custom-profile-avatar/custom-profile-avatar";
import { Typography } from "antd";

const ViewDetailsTeachers = (teachers) => {
  const column = [
    {
      key: "name",
      title: "Teacher Name",
      dataIndex: "name",
      sorter: (a, b) => (a.name || "").localeCompare(b.name || ""),
      render: (value, record) => (
        <div className={styles.nameContainer}>
          <CustomProfileAvatar
            image={record?.profile_picture || "sample-user.png"}
            imageName={record?.name}
            imageSrc={
              record?.profile_picture ?? "assets/images/sample-user.png"
            }
            divBackgroundColor={"#97a997"}
          />
          <Typography>{value}</Typography>
        </div>
      ),
    },
    {
      key: "gender",
      title: "Gender",
      dataIndex: "gender",
      sorter: (a, b) => (a.gender || "").localeCompare(b.gender || ""),
    },
    {
      key: "id",
      title: "Username",
      dataIndex: "resgistration_number",
      sorter: (a, b) =>
        (a.resgistration_number || "").localeCompare(
          b.resgistration_number || ""
        ),
    },
    {
      key: "status",
      title: "Attendance Status",
      dataIndex: "status",
      sorter: (a, b) => (a.status || "").localeCompare(b.status || ""),
      render: (status) => {
        const colorMap = {
          PRESENT: "#3BB44B",
          ABSENT: "#d93025",
          "NOT MARKED": "blue",
        };

        const bgColorMap = {
          PRESENT: "#ECF8ED",
          ABSENT: "rgba(217, 48, 37, 0.1)",
          "NOT MARKED": "#ECF8ED",
        };

        return (
          <span
            className={styles.statusPill}
            style={{
              backgroundColor: bgColorMap[status],
              color: colorMap[status],
            }}
          >
            <span
              className={styles.statusDot}
              style={{ backgroundColor: colorMap[status] }}
            />
            <span>{status}</span>
          </span>
        );
      },
    },
  ];

  return (
    <CustomTable
      pagination={false}
      columns={column}
      dataSource={teachers.teachers}
    />
  );
};
export default ViewDetailsTeachers;
